// extracted by mini-css-extract-plugin
export default {"usrDetLong":"GetSpecialRemarks_usrDetLong__Tikry","txtArea":"GetSpecialRemarks_txtArea__pDdiC"};